const MuiCard = {
    root: {
        padding: '16px',
        border: 'none',
    },
};

export default MuiCard;